module.exports = __webpack_public_path__ + "static/media/img121.af798852.jpg";